// Copyright (c) 2024 Deere & Company

import {
    processSelectedPinPlates,
    resetRegistrationReviewFacets,
    updateFactoryDuplicatePinPlateResults,
    updateSelectedPinPlates
} from './factory-duplicate-pin-plates';
import {
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateFacetsDeliveryDateRange,
    updateFacetsRegistrationDateRange
} from './facets';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import sharedActionCreators from '../../shared/action-creators';
import {updateTransferResultsWithFacets} from '../../transfers/action-creators/facet-updates';

export default {
    ...exportToExcelActions,
    ...sharedActionCreators,
    processSelectedPinPlates,
    resetRegistrationReviewFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateFacetsDeliveryDateRange,
    updateFacetsRegistrationDateRange,
    updateFactoryDuplicatePinPlateResults,
    updateSelectedPinPlates,
    updateTransferResultsWithFacets
};



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/action-creators/index.js